import React from 'react';
import Main from '../../components/Main';

//Function Subpage of OurLeaders Page

const Function = () => {
  return (
    <div>
      <Main componentList={[
      <div>
        <h1>Function</h1>
        <p>This is the Function page.</p>
     </div>]} />
    </div>
  );
};

export default Function;